import React, {Component} from 'react'
import {Container, FormGroup, Input, Label} from 'reactstrap'
import {connect} from 'react-redux'
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth'
import firebase from "firebase";
import MemberRegistration from '../MemberRegistration/MemberRegistration'
import {withRouter} from 'react-router-dom'
import {isAuth} from '../../Utils/firebaseUtils'
import {MDBContainer} from "mdbreact";
import classes from "../RouterManager/RouterManager.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";

import common from '../../Utils/common.module.css'

const db = firebase.firestore()

const uiConfig = {
    signInFlow: 'popup',
    signInSuccessUrl: '/login',
    signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ]
}

class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <Container>
                {
                    isAuth(this.props.auth) ?
                    <MemberRegistration/>
                    :
                    <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
                }
            </Container>

        )
    }
}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default withRouter(enhance(LoginPage))